<template>
    <div class="video-input">
        <div v-if="value && value.preview" class="mt-2 relative">
            <video
                :src="value.preview"
                class="w-full h-32 object-cover rounded"
                controls
                muted
            ></video>
            <button
                v-if="remove !== false"
                @click="removeVideo"
                type="button"
                class="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
            >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
        <div class="mt-2">
            <input
                type="file"
                :accept="accept"
                @change="handleFileChange"
                class="form-input block w-full sm:text-sm sm:leading-5"
            />
            <p v-if="value && value.file" class="mt-1 text-sm text-gray-500">
                Selected: {{ value.file.name }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'video-input',
    props: {
        value: {
            type: Object,
            default: null
        },
        accept: {
            type: String,
            default: 'video/mp4,video/webm'
        },
        remove: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.$emit('input', {
                        file: file,
                        preview: e.target.result
                    });
                };
                reader.readAsDataURL(file);
            }
        },
        removeVideo() {
            this.$emit('input', null);
        }
    }
}
</script>
